import { AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, Type, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ComponentService } from '../../services/component.service';
import { messagefromComponent } from '../../class/appinterface';
import { costantValue } from '../../services/forms-template.service';
export class _datiDetail {
  chiave: any;
  titolo: string;
  api: string;
  type?: 'table' | 'customComponent';
  configComponent?: {
    [key: string]: any;
    componentName: string;
    idComponent: string;
    dataSourceKey?: string;
  };
  classe?: string;
  name?: string;
  wingap?: boolean;
  modeEdit?: "popup" | "batch" | "nicaform" | "customComponent" | "row" | "nicaforminternal";
  service?: string;
  masterKey?: string;
  isAdvancedXlsExportAvailable?: boolean
  isExportDocxAvailable?: boolean
  isExportExcelAvailable?: boolean
  isExportPDFAvailable?: boolean
  columnHidingEnabled?: boolean;
  costantValues?: any[]
  filter?: string;
  subDetail?: _datiDetail[];
  path?: string;
  chiaviDettagli?: boolean
  defaultFormDisabled?: boolean
  queryString?: string
  modifica?: boolean
  rimuovi?: boolean
  aggiungi?: boolean
  TextAddRowButton?: string
}
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('nicaAnagraficaComponent', { static: false }) nicaAnagraficaComponent: NicaAnagraficaComponent
  @ViewChildren('dynamicCustomComponentContainer', { read: ViewContainerRef }) dynamicCustomComponentContainer!: QueryList<ViewContainerRef> | undefined;
  dynamicCustomComponentMap = new Map<string, ComponentRef<any>[]>();
  @Input() key: any;
  @Input() chiavi: _datiDetail[] = [];
  @Input() api: any[];
  @Input() queryString: string = '';
  @Input() width: any;
  @Input() data: any;
  @Input() height: any;
  @Input() aggiungi: any = true;
  @Input() rimuovi: any = true;
  @Input() modifica: any = true;
  @Input() defaultFormDisabled: boolean = false;
  @Input() wingap = true
  @Input() masterDetailItem
  @Input() type: 'table' | 'customComponent' = 'table'
  costantValues: costantValue[]
  @Output() emitEventEditor: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  $distruggi: Subject<void> = new Subject<void>()
  filter: string = '';
  _chiave: any;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private componentService: ComponentService) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.processCostantValue()
  }

  ngOnDestroy(): void {
    this.$distruggi.next()
    this.$distruggi.complete()
    this.$distruggi.unsubscribe()
    this.clearTuttiDynamicComponent()
  }

  ngAfterViewInit() {
    if (this.key) this._chiave = this.key; else this._chiave = ''
    if (this.type === 'customComponent') {
      setTimeout(() => {
        this.chiavi.forEach((chiave) => {
          const dataToSend = this.processaDataToSendDynamic(chiave.configComponent)
          console.log(dataToSend)
          const containerId = chiave.name
          const componentId = chiave.configComponent.idComponent
          const componentName = chiave.configComponent.componentName
          this.aggiungiDynamicComponent(containerId, componentName, componentId, dataToSend)
        })
      }, 100)
    }
  }

  ngOnInit() {
    if (this.key) this._chiave = this.key; else this._chiave = ''
    if (this.queryString > '') {
      this.queryString = this.processFiltro(this.queryString, this.data);
    }
    this.processCostantValue()
    this.componentService.castMessage.pipe(takeUntil(this.$distruggi)).subscribe((messaggio: messagefromComponent) => {
      return this.processaMessaggio(messaggio)
    })

  }

  onEditorPrepared(e) {
    if (e.name == 'onInitilized') {
      if (typeof this.chiavi[0]['colonne'] != 'undefined') {
        e.contentComponent.colonneGrigliaTabella = this.chiavi[0]['colonne'];
      }
      e.name = "masterDetailInitilized";
      e.detailRif = this.chiavi;
      //e.contentComponent=this.nicaAnagraficaComponent;
      e.masterComponent = this;

    }


    if (e.name == 'onEditorPrepared') {
      e.name = 'masterDetailEdit';
      e.detailRif = this.chiavi;

      //e.event. e.event
    }


    if (e.name == 'onInitNewRow') {

      e.name = 'masterDetailInsert';
      e.detailRif = this.chiavi;
      e.data = this.data;

    }


    if (e.name == 'onSelectionChanged') {
      e.name = 'masterDetailSelection';
      e.detailRif = this.chiavi;
    }
    if (e.name == 'onContentReady') {
      e.name = 'masterDetailContentReady';

      e.detailRif = this.chiavi;
      e.DetailComponent = e.component;
    }
    this.emitEventEditor.emit(e)
  }

  detailOptionaButtonClick(e) {
    e.nameButton = e.name
    e.name = 'masterDetailOptionaButtonClick';
    this.emitEventEditor.emit(e)
  }

  processaMessaggio(messaggio: messagefromComponent) {
    return
  }

  aggiungiDynamicComponent(containerId: string, componentName: string, componentId: string, data?: any) {
    //trova il contenitore
    const container = this.getContainerById(containerId);
    if (!container) {
      console.error(`Container con ID ${containerId} non trovato.`);
      return;
    }
    // Creare il componente dinamico
    const factories = Array.from(this.componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(factoryClass);
    const componentRef = container.createComponent(componentFactory);
    const createdNativeElement = container.element.nativeElement;
    createdNativeElement.appendChild(componentRef.location.nativeElement);
    // Impostiamo l'ID direttamente sull'elemento appena creato
    componentRef.location.nativeElement.setAttribute('id', componentId);
    //passa i dati
    if (data) {
      Object.assign(componentRef.instance, data);
    }
    // Memorizziamo i componenti caricati nel container nella mappa
    if (!this.dynamicCustomComponentMap.has(containerId)) {
      this.dynamicCustomComponentMap.set(containerId, []);
    }
    this.dynamicCustomComponentMap.get(containerId)!.push(componentRef);
    // Intercetta e sottoscrive TUTTI gli EventEmitter automaticamente
    Object.keys(componentRef.instance).forEach(property => {
      const propertyValue = (componentRef.instance as any)[property];
      if (propertyValue instanceof EventEmitter) {
        propertyValue.pipe(takeUntil(this.$distruggi)).subscribe((eventData: any) => {
          let evento = eventData
          if (typeof eventData === 'object') {
            evento['dynamicComponent'] = componentName || ''
          } else {
            evento = {
              event: eventData,
              dynamicComponent: componentName || ''
            }
          }
          //TODO-----------------------------------------------
          this.emitEventEditor.emit(evento)
        });
      }
    });
    return
  }

  //processa i dati da mandare al componente per avere dati dinamici modificare qui
  processaDataToSendDynamic(configuration: { [key: string]: any }) {
    let dataSend: { [key: string]: any } = {};
    let config = { ...configuration };
    console.log(config)
    if (config) {
      Object.keys(config).forEach((key) => {
        switch (key) {
          case 'componentName':
          case 'idComponent':
            return;
          case 'queryString':
            config['queryString'] = config['queryString'] !== ''
              ? this.processFiltro(config['queryString'], this.data)
              : this.processFiltro(this.queryString, this.data);
            break;

          case 'dataSourceKey':
            dataSend[config['dataSourceKey']] = this.data;
            return;
          default:
            dataSend[key] = config[key];
            return;
        }
        dataSend[key] = config[key];
      });
    }
    console.log(dataSend)
    return dataSend;
  }

  //processa il filtro tipo ?id=[id] in ?id=1 prendendo i valori da dataJson
  processFiltro(query, data) {
    return query.replace(/\[([^\]]+)\]/g, (match, variable) => {
      return data.hasOwnProperty(variable) ? data[variable] : match;
    });
  }

  //TODO ----------------------------------------------------------------
  processCostantValue(): void {
    if (!this.chiavi) return;

    this.chiavi.forEach((chiave) => {
      if (!chiave.costantValues) return;
      this.costantValues = chiave.costantValues.map(cv => ({ ...cv }));
      this.costantValues.forEach((costante: costantValue) => {
        const valore = costante.value;
        if (typeof valore === 'string' && valore.startsWith('[') && valore.endsWith(']')) {
          const match = valore.match(/^\[(.*)\]$/);
          if (match && match[1]) {
            const chiaveInterna = match[1].trim();
            const valoreSostituito = this.data[chiaveInterna];

            if (valoreSostituito !== undefined) {
              costante.value = valoreSostituito;
            }
          }
        }
      });

      // DEBUG
      /* console.log("Copia (modificata):", this.costantValues);
      console.log("Originale (immutato):", chiave.costantValues); */
    });
  }


  //TODO ----------------------------------------------------------------
  //cancella tutti componenti dinamici creati svuotando la mappa e i container
  clearTuttiDynamicComponent() {
    if (this.dynamicCustomComponentMap) {
      // Iteriamo su tutti i contenitori registrati in componentsMap
      this.dynamicCustomComponentMap.forEach((components) => {
        // Distruggiamo ogni componente
        components.forEach(comp => comp.destroy());
      });
      // Svuotiamo la mappa
      this.dynamicCustomComponentMap.clear();
    }
    if (this.dynamicCustomComponentContainer) {
      // Puliamo anche i contenitori ViewContainerRef
      this.dynamicCustomComponentContainer.forEach(container => container.clear());
    }
    return;
  }

  //cancella i componenti dinamici creati nel container
  clearDynamicComponentContainer(containerId: string) {
    const components = this.dynamicCustomComponentMap.get(containerId);
    if (components) {
      components.forEach(comp => comp.destroy()); // Distrugge tutti i componenti nel container
      this.dynamicCustomComponentMap.delete(containerId); // Rimuove il riferimento nella mappa
    }
    // Troviamo il ViewContainerRef associato e lo puliamo
    const container = this.getContainerById(containerId);
    if (container) {
      container.clear();
    }
    return
  }

  //cancella il componente creato nel container
  clearDynamicComponentId(containerId: string, componentId: string) {
    const components = this.dynamicCustomComponentMap.get(containerId); // Ottieni l'array completo
    if (!components || components.length === 0) {
      return;
    }
    // Trova l'indice del componente con l'ID specificato
    const index = components.findIndex(comp => comp.location.nativeElement.id === componentId.toString());
    if (index !== -1) {
      components[index].destroy(); // Distrugge il componente
      components.splice(index, 1); // Rimuove il riferimento dalla lista
      // Se il contenitore è ora vuoto, rimuoviamolo dalla mappa
      if (components.length === 0) {
        this.dynamicCustomComponentMap.delete(containerId);
      }
    }
    return
  }

  //ritorna il container con l'id associato
  getContainerById(containerId: string): ViewContainerRef | undefined {
    if (this.dynamicCustomComponentContainer) {
      // console.error(this.dynamicCustomComponentContainer)
      return this.dynamicCustomComponentContainer.find((container: any) => {
        //console.error(container)
        return container.element.nativeElement.id === containerId;
      });
    } else {
      return undefined
    }
  }

}
